import React, { useState } from 'react';
import BlueEnvelopeProgramOverview from './docs/BlueEnvelopeProgramOverview';
import BlueEnvelopeConsideration from './docs/BlueEnvelopeConsideration';
import BlueEnvelopeDriverGuidance from './docs/BlueEnvelopeDriverGuidance';

const DOC_TABS = [
  { id: 'overview', label: 'Program Information Overview' },
  { id: 'context', label: 'Context and Considerations' },
  { id: 'driver', label: 'Driver Guidance' },
];

export default function BlueEnvelopeOtherDocuments() {
  const [activeTab, setActiveTab] = useState('overview');

  const renderDocument = () => {
    switch (activeTab) {
      case 'overview':
        return <BlueEnvelopeProgramOverview />;
      case 'context':
        return <BlueEnvelopeConsideration />;
      case 'driver':
        return <BlueEnvelopeDriverGuidance />;
      default:
        return <BlueEnvelopeProgramOverview />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-2 md:p-6 flex flex-col-reverse md:flex-row gap-2 md:gap-6">
      {/* Main content – document view */}
      <div className="flex-1 min-w-0 flex justify-start">
        {renderDocument()}
      </div>

      {/* Tab buttons – right side */}
      <div className="w-full md:w-56 flex-shrink-0 flex flex-row md:flex-col gap-2">
        {DOC_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={`w-full px-2 md:px-4 py-3 rounded-lg text-left font-semibold text-sm transition-colors border-2 ${
              activeTab === tab.id
                ? 'bg-purple-600 text-white border-purple-600'
                : 'bg-white text-gray-700 border-gray-200 hover:border-purple-400 hover:bg-sky-50'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
